const STORAGE_PREFIX = 'twinnee_export_job:';

/** @param {{ storyId?: string, projectId?: string }} ids */
export function exportJobStorageKey({ storyId, projectId }) {
  if (projectId) return `${STORAGE_PREFIX}narration:${projectId}`;
  if (storyId) return `${STORAGE_PREFIX}story:${storyId}`;
  return null;
}

/** @param {string | null | undefined} key @param {string} jobId */
export function saveActiveExportJob(key, jobId) {
  if (key && jobId) localStorage.setItem(key, jobId);
}

/** @param {string | null | undefined} key */
export function clearActiveExportJob(key) {
  if (key) localStorage.removeItem(key);
}

/** @param {string | null | undefined} key */
export function loadActiveExportJob(key) {
  if (!key) return null;
  return localStorage.getItem(key);
}

/**
 * Poll export job status until terminal state.
 * @returns {() => void} stop polling
 */
export function pollExportJob(api, jobId, { onProgress, intervalMs = 2000 } = {}) {
  let timer = null;
  let stopped = false;

  const stop = () => {
    stopped = true;
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  };

  const tick = async () => {
    if (stopped) return;
    try {
      const { data: job } = await api.get(`/jobs/${jobId}`, { params: { detail: 'poll' } });
      onProgress?.(job);
      const terminal = ['completed', 'failed', 'cancelled'].includes(job?.status);
      if (terminal) stop();
    } catch (_) {
      /* keep polling — network may recover */
    }
  };

  tick();
  timer = setInterval(tick, intervalMs);
  return stop;
}
